import React, { Component } from 'react';
import { Table, Row, Button, message, Spin, DatePicker, Icon, Popconfirm, } from 'antd';
import moment from 'moment';
import { dataDefault } from './data';
import imgSave from "../..//saveImg";
import Auth from "../../Auth";
import TableText from "../../TableText";
import { numConvert } from "@/method";
import Title from './Title'
import FileSaver from "file-saver";

const { MonthPicker } = DatePicker;
const defaultTitle = { taker: "", att1: "", att: "", office1: "", office: "", venue: "", date: moment().format('YYYY-MM-DD HH:mm:ss') };
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().format('YYYY-MM'),
            data: [],
            title: { ...defaultTitle },
            loading: true,
            loadingSave: false,
            print: false,
            update: false,
            hotelName: sessionStorage.getItem('hotelName') || ""
        }
    }

    componentDidMount() {
        this.getDateData(this.state.date);
    }

    computeNum = async (data) => {
        this.setState({ data });
    }
    onChange = (name, value, i) => {
        // 简单粗暴的深拷贝
        let data = JSON.parse(JSON.stringify(this.state.data));
        data[i][name] = value;
        this.computeNum(data);
    }
    getDateData = async (date) => {
        const dataBegin = JSON.stringify(dataDefault);
        let data = JSON.parse(dataBegin);

        fetch(`/meetingMinutesInfo?year=${moment(date).format('YYYY')}&month=${moment(date).format('MM')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.data && x.data.data.length > 0) {
                data = x.data.data.sort((a, b) => {
                    return numConvert(a.sort) - numConvert(b.sort)
                });
            }

            this.setState({
                loading: false,
                title: { ...defaultTitle, ...x.data.title, }
            }, () => {
                this.computeNum(data);
            });

        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let { date, title } = this.state;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("MM");
        let data = this.state.data.map(x => ({ ...x, year, month }));


        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        dataFrom.append('title', JSON.stringify({ ...title, year, month }));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/meetingMinutesSave', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (data.some(item => !item.id)) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table3_3_4', 1.5, '4.14', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });
    }

    // 点击增加行数
    addRow = (record, index) => {
        let data = this.state.data;
        this.setState({ data: [], loading: true }, () => {
            const obj = {
                sort: index,
                issues: "",
                plan: "",
                by: ""
            }
            data.splice(index, 0, obj);

            data = data.map((item, i) => ({ ...item, sort: i }));

            this.setState({ data, loading: false });
        });

    }

    // 删除行
    onClose = (index, record) => {
        let data = this.state.data;
        if (record.id) {
            fetch('/meetingMinutesDel?id=' + record.id, { credentials: 'include' }).then(x => x.json()).then(res => {
                if (res.status == 1) {
                    message.success(res.msg);
                    data.splice(index, 1);
                    data = data.map((x, i) => ({ ...x, sort: i }));
                    this.setState({ data: [], loading: true }, () => {
                        this.setState({
                            data,
                            loading: false
                        });
                    });
                } else {
                    message.success(res.msg)
                }
            }).catch(err => {
                console.error(err);
                message.success('删除失败！')
            })
        } else {
            data.splice(index, 1);
            data = data.map((x, i) => ({ ...x, sort: i }));
            this.setState({ data: [], loading: true }, () => {
                this.setState({
                    data,
                    loading: false
                });
            });
        }

    }
    onExpoetExcel = () => {
        this.setState({ print: true, loading: true }, () => {
            const name = `会议记录${moment(this.state.date).format('YYYY-MM')}`;
            const innerHtml = `
              <caption>${name}</caption>
              ${document.getElementById('table').innerHTML.replace(/<table class="">/g, '<table border="1">')}
            `;

            var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
            var blob = new Blob([html], { type: "application/vnd.ms-excel" });
            FileSaver.saveAs(blob, `${name}.xls`);
            this.setState({ print: false, loading: false });
        });
    }
    render() {
        const { data, title, date, hotelName } = this.state;
        const len = data.length - 1;
        const month = moment(date).format('M');
        const columns = [{
            title: 'No.',
            dataIndex: 'sort',
            key: 'sort',
            align: "center",
            width: 50,
            render: (text, record, index) => {
                text++;
                const props = { text, index, type: 'text', name: "no", onChange: this.onChange, totalIndex: [len] };
                if (index == len) {
                    return (
                        <Icon type="plus-circle" style={{ color: "#1890ff", cursor: "pointer" }} onClick={this.addRow.bind(this, record, index)} />
                    )
                }
                if (index > 4 && index < len) {
                    return record.id ?
                        <Popconfirm title="确定删除?一旦删除数据将不可恢复!" onConfirm={this.onClose.bind(this, index, record)} onCancel={() => { }} okText="确定" cancelText="取消">
                            <Icon type="minus-circle" style={{ color: "red", cursor: "pointer" }} />
                        </Popconfirm>
                        :
                        <Icon type="minus-circle" style={{ color: "red", cursor: "pointer" }} onClick={this.onClose.bind(this, index, record)} />
                }
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: "Issues",
            dataIndex: 'issues',
            key: 'issues',
            align: "center",
            width: 300,
            render: (text, record, index) => {
                const title = ['Issues'];
                const props = {
                    text, index, type: index < len ? 'textArea' : 'text', name: "issues", onChange: this.onChange, totalIndex: [len],
                    compared: {
                        title,
                        record,
                        sqlName: "meetingMinutes"
                    }
                };
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: "Action Plan",
            dataIndex: 'plan',
            key: 'plan',
            align: "center",
            width: 300,
            render: (text, record, index) => {
                const title = ['Action Plan'];
                const props = {
                    text, index, type: index < len ? 'textArea' : 'text', name: "plan", onChange: this.onChange, totalIndex: [len],
                    compared: {
                        title,
                        record,
                        sqlName: "meetingMinutes"
                    }
                };
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: "Followed by",
            dataIndex: 'by',
            key: 'by',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['Followed by'];
                const props = {
                    text, index, type: index < len ? 'textArea' : 'text', name: "by", onChange: this.onChange, totalIndex: [len],
                    compared: {
                        title,
                        record,
                        sqlName: "meetingMinutes"
                    }
                };
                return (
                    <TableText data={props} />
                )
            }
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table" style={{ width: 1200 }}>
                    <Row className="title" id="table3_3_4" >
                        <Row>
                            P&L Review for （{month}）–（{hotelName.replace(/[^a-zA-Z]/g, '')}）Meeting Minutes 会议记录-（{hotelName.replace(/[^\u4E00-\u9FA5]/g, '')}）（{month}）经营评估会议
                        </Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        <Title data={title} onChange={(name, value) => this.setState({ title: { ...title, [name]: value } })} />
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            id="table"
                            pagination={false}
                            className="content"
                            scroll={this.state.print ? {} : { y: 500, }}
                            rowKey={(record, index) => index}
                        />
                    </Row>

                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={() => {
                                this.setState({ print: true }, () => {
                                    this.onExpoetExcel();
                                });
                            }}
                        >导出Excel</Button>
                        <Auth loading={this.state.loading} auth="edit_meetingMinutes">
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Auth>
                    </Row>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/other/meetingMinutes/index.js